import axiosPost from '../axiosPost';

export const feriadosDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "FeriadoDel",
        "params": {
            "feriadoId": id
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}